<app-pan-modal #newShoppersenseModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Add New ShopperSense</div>
  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>ShopperSense Serial Number</app-pan-floating-label>
      <input panInput [(ngModel)]="newShoppersenseSerialNumber" placeholder="ShopperSense Serial Number..." />
    </app-pan-form-control>

    <app-page-select-branch
      [(selected)]="newShoppersenseBranch"
      [autoSelectBranchIds]="[branchId()]"
      [disabled]="true"
      (selectedChange)="loadLocations()"
    ></app-page-select-branch>

    <app-pan-form-control>
      <app-pan-floating-label>Location</app-pan-floating-label>

      <ng-select
        class="w-full mb-2"
        placeholder="Select location..."
        [items]="locations()"
        [bindLabel]="'name'"
        appendTo="body"
        [virtualScroll]="true"
        [disabled]="!newShoppersenseBranch() || isLoadingLocations()"
        [(ngModel)]="newShoppersenseLocation"
        (ngModelChange)="loadCameras()"
        [loading]="isLoadingLocations()"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Camera</app-pan-floating-label>

      <div class="flex gap-2 mb-2">
        <ng-select
          class="flex-1 max-w-[75%]"
          placeholder="Select camera..."
          [items]="cameras()"
          [bindLabel]="'camera_name'"
          appendTo="body"
          [virtualScroll]="true"
          [disabled]="!newShoppersenseLocation() || isLoadingCameras()"
          [loading]="isLoadingCameras()"
          [(ngModel)]="newShoppersenseCamera"
          (ngModelChange)="loadCameraSnapshot($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="flex justify-between">
              {{ item.camera_name }}

              <app-pan-video-status
                class="absolute right-2"
                [status]="item.status === 'GREEN' ? 'healthy' : 'unhealthy'"
              ></app-pan-video-status>
            </div>
          </ng-template>
        </ng-select>

        <app-pan-button
          color="info"
          icon="refresh"
          (click)="loadCameras()"
          [disabled]="!newShoppersenseLocation() || isLoadingCameras()"
          matTooltip="It may take 60 seconds or more for updated cameras to show up, and you may have to refresh multiple times for your newest camera to show up."
        ></app-pan-button>
      </div>
    </app-pan-form-control>

    @if (newShoppersenseCamera()) {
      @let cameraUrl = viewCameraUrl();
      @if (!cameraUrl) {
        <app-pan-blank-slate>
          <app-pan-spinner size="lg"></app-pan-spinner>
        </app-pan-blank-slate>
      } @else if (cameraUrl === "error") {
        <app-pan-inline-alert [type]="'danger'">Could not load preview for this camera.</app-pan-inline-alert>
      } @else {
        <app-pan-section-header class="mb-2" [title]="'Camera Snapshot Preview'"></app-pan-section-header>
        <img [src]="cameraUrl" alt="camera preview for {{ newShoppersenseCamera()?.camera_name }}" />
      }
    }
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button
      panModalClose
      color="primary"
      (click)="addShoppersense()"
      [disabled]="!newShoppersenseSerialNumber() || !newShoppersenseBranch() || !newShoppersenseCamera() || !newShoppersenseLocation()"
      >Connect ShopperSense</app-pan-button
    >
  </div>
</app-pan-modal>

<app-pan-section-header class="mt-4" title="ShopperSense Configurations">
  <div action class="flex gap-2">
    <app-pan-button icon="add" color="primary" (click)="newShoppersenseModal.show()"></app-pan-button>
  </div>
</app-pan-section-header>

<ag-grid-angular
  #locationGrid
  [rowData]="shoppersenses()"
  [columnDefs]="shoppersenseColumns"
  [gridOptions]="shoppersenseTable"
></ag-grid-angular>
